"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERC721ReceiverMock__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "enum ERC721ReceiverMock.Error",
    name: "error",
    type: "uint8"
  }],
  name: "setErrorType",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class ERC721ReceiverMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.ERC721ReceiverMock__factory = ERC721ReceiverMock__factory;
_defineProperty(ERC721ReceiverMock__factory, "bytecode", _bytecode);
_defineProperty(ERC721ReceiverMock__factory, "abi", _abi);